export var TenantConfigNavigationType;
(function (TenantConfigNavigationType) {
    TenantConfigNavigationType["Hierarchy"] = "HIERARCHY";
    TenantConfigNavigationType["Projects"] = "PROJECTS";
    TenantConfigNavigationType["Custom"] = "CUSTOM";
})(TenantConfigNavigationType || (TenantConfigNavigationType = {}));
export var SupportService;
(function (SupportService) {
    SupportService["Zendesk"] = "zendesk";
    SupportService["Intercom"] = "intercom";
})(SupportService || (SupportService = {}));
export var TenantType;
(function (TenantType) {
    TenantType["Agency"] = "agency";
    TenantType["Client"] = "client";
    TenantType["MultiClient"] = "multi-client";
})(TenantType || (TenantType = {}));
export var DefaultHierarchyLevelType;
(function (DefaultHierarchyLevelType) {
    DefaultHierarchyLevelType["Tenant"] = "TENANT";
    DefaultHierarchyLevelType["Client"] = "CLIENT";
    DefaultHierarchyLevelType["Market"] = "MARKET";
    DefaultHierarchyLevelType["Brand"] = "BRAND";
    DefaultHierarchyLevelType["Region"] = "REGION";
    DefaultHierarchyLevelType["Industry"] = "INDUSTRY";
})(DefaultHierarchyLevelType || (DefaultHierarchyLevelType = {}));
